import TopLevelSite from 'src/constants/topLevelSite';
import { useSelector } from 'src/modules/useSelector';

export const useTopLevelSite = (): TopLevelSite => {
    const host = useSelector((state) => state.topLevelSite);
    return host ?? TopLevelSite.RU;
};

export const useIsHHru = (): boolean => {
    const host = useTopLevelSite();
    return host === TopLevelSite.RU;
};

export const useIsZP = (): boolean => {
    const host = useTopLevelSite();
    return host === TopLevelSite.ZP;
};

export const useIsRabotaBy = (): boolean => {
    const host = useTopLevelSite();
    return host === TopLevelSite.BY;
};

export const useIsHhKz = (): boolean => {
    const topLevelSite = useTopLevelSite();
    return topLevelSite === TopLevelSite.KZ;
};
